import script from "./UnitResidentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitResidentCard.vue?vue&type=script&setup=true&lang=js"

import "./UnitResidentCard.vue?vue&type=style&index=0&id=72fc2f25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fc2f25"]])

export default __exports__